/**
 * Get the comparison label based on the selected date range option
 * @param dateOption - The selected date option (can be label like "Today" or value like "today")
 * @returns The comparison label string, or null/empty for Custom to hide comparison
 */
export const getComparisonLabel = (
  dateOption: string | null | undefined
): string | null => {
  if (!dateOption) {
    return null; // Hide comparison if no option selected
  }

  const normalizedOption = dateOption.toLowerCase().trim();

  // Handle "today" or "Today"
  if (normalizedOption === "today") {
    return "vs Yesterday";
  }

  // Handle "last7days", "last 7 days", "Last 7 Days"
  if (normalizedOption === "last7days" || normalizedOption === "last 7 days") {
    return "vs Last Week";
  }

  // Handle "last30days", "last 30 days", "Last 30 Days"
  if (
    normalizedOption === "last30days" ||
    normalizedOption === "last 30 days"
  ) {
    return "vs Previous 30 Days";
  }

  // Handle "last3months", "last 3 months", "Last 3 Months"
  if (
    normalizedOption === "last3months" ||
    normalizedOption === "last 3 months"
  ) {
    return "vs Previous 3 Months";
  }

  // Handle "last6months", "last 6 months", "Last 6 Months"
  if (
    normalizedOption === "last6months" ||
    normalizedOption === "last 6 months"
  ) {
    return "vs Previous 6 Months";
  }

  // Handle "last12months", "last 12 months", "Last 12 Months"
  if (
    normalizedOption === "last12months" ||
    normalizedOption === "last 12 months"
  ) {
    return "vs Previous 12 Months";
  }

  // Return null for Custom to hide comparison
  if (normalizedOption === "custom") {
    return null;
  }

  // Default: hide comparison for unknown options
  return null;
};
